import React, { useCallback, useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import SettingsPage from './components/SettingsPage';
import DashboardHome from './components/DashboardHome';
import ServiceEmbed from './components/ServiceEmbed';
import Login from './components/Login';
import AppShell from './layout/AppShell';
import { SERVICE_DEFS } from './config/services';
import { hashForRoute, parseHashRoute } from './routing/hashRoute';
import './App.css';

const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();
  const [route, setRoute] = useState(() => parseHashRoute(window.location.hash));

  useEffect(() => {
    const onHashChange = () => setRoute(parseHashRoute(window.location.hash));
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const navigate = useCallback((next) => {
    const hash = hashForRoute(next);
    if (hash) {
      window.location.hash = hash;
    } else {
      const base = window.location.pathname + window.location.search;
      window.history.replaceState(null, '', base);
    }
    setRoute(next);
  }, []);

  const shellView =
    route.kind === 'settings' ? 'settings' : route.kind === 'service' ? 'service' : 'home';

  const goHome = () => navigate({ kind: 'home' });
  const openSettings = () => navigate({ kind: 'settings' });
  const openService = (serviceKey) => navigate({ kind: 'service', serviceKey });

  if (loading) {
    return (
      <div
        className="App"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 16,
          background: '#f8fafc',
          color: '#0f172a',
        }}
      >
        <div style={{ width: 32, height: 32, border: '3px solid #e2e8f0', borderTopColor: '#2563eb', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        <div>Проверка сессии…</div>
        <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  let mainContent;
  if (route.kind === 'settings') {
    mainContent = <SettingsPage initialTab={route.tab} />;
  } else if (route.kind === 'service') {
    const def = SERVICE_DEFS[route.serviceKey];
    mainContent = <ServiceEmbed path={def.href} title={def.title} />;
  } else {
    mainContent = <DashboardHome />;
  }

  return (
    <div className="App">
      <AppShell
        view={shellView}
        activeServiceKey={route.kind === 'service' ? route.serviceKey : null}
        onNavigate={(v) => (v === 'home' ? goHome() : openSettings())}
        onOpenService={openService}
        onOpenSettings={openSettings}
      >
        {mainContent}
      </AppShell>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
